<template>
  <div>
    <v-row class="mb-2" align="center">
      <v-col cols="12" sm="6" md="4">
        <v-chip
          small
          :color="sumaPorcentaje === 100 ? 'green' : (sumaPorcentaje > 100 ? 'red' : 'orange')"
          dark
          class="mr-2"
        >
          Suma % activos: {{ sumaPorcentaje }}%
        </v-chip>
        <span class="text-caption grey--text">Ideal 100% (no bloquea el job)</span>
      </v-col>
      <v-col cols="12" sm="6" md="8" class="text-right">
        <v-btn
          color="primary"
          small
          dark
          class="mr-2 text-capitalize"
          tile
          @click="abrirNuevo"
        >
          <v-icon small left>mdi-plus</v-icon>
          Agregar
        </v-btn>
        <v-btn
          color="primary"
          small
          dark
          class="text-capitalize"
          tile
          :loading="cargando"
          @click="cargarPool"
        >
          <v-icon small left>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
      </v-col>
    </v-row>

    <v-alert dense text type="info" class="mb-3">
      Pool de vendedoras humanas que reciben contactos cuando Susana hace timeout / handoff.
      No se mezcla con la distribución de entrada (planteles).
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="pool"
      :loading="cargando"
      dense
      class="elevation-0"
      :mobile-breakpoint="100"
      item-key="id"
    >
      <template v-slot:item.activo="{ item }">
        <v-switch
          v-model="item.activo"
          :true-value="1"
          :false-value="0"
          dense
          hide-details
          class="mt-0"
          @change="toggleActivo(item)"
        ></v-switch>
      </template>

      <template v-slot:item.porcentaje="{ item }">
        <v-edit-dialog
          :return-value.sync="item.porcentaje"
          @save="guardarPorcentaje(item)"
        >
          {{ item.porcentaje }}%
          <template v-slot:input>
            <v-text-field
              v-model.number="item.porcentaje"
              label="%"
              type="number"
              single-line
              min="0"
              max="100"
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon x-small color="primary" class="mr-1" @click="abrirEditar(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon x-small color="red" @click="confirmarEliminar(item)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:no-data>
        <div class="py-4 text-center grey--text">
          Sin vendedoras en el pool. Agrega al menos una con % &gt; 0.
        </div>
      </template>
    </v-data-table>

    <v-divider class="my-4"></v-divider>

    <div class="d-flex align-center mb-2">
      <span class="text-subtitle-2">Eventos recientes</span>
      <v-spacer></v-spacer>
      <v-btn x-small text color="primary" :loading="cargandoEventos" @click="cargarEventos">
        <v-icon x-small left>mdi-refresh</v-icon>
        Recargar
      </v-btn>
    </div>

    <v-data-table
      :headers="headersEventos"
      :items="eventos"
      :loading="cargandoEventos"
      dense
      class="elevation-0"
      :mobile-breakpoint="100"
      hide-default-footer
      :items-per-page="10"
    >
      <template v-slot:item.fecha="{ item }">
        {{ formatFecha(item.fecha) }}
      </template>
      <template v-slot:item.dry_run="{ item }">
        <v-chip x-small :color="item.dry_run ? 'orange' : 'green'" dark>
          {{ item.dry_run ? 'dry' : 'real' }}
        </v-chip>
      </template>
    </v-data-table>

    <!-- Dialog alta / edición -->
    <v-dialog v-model="dialogForm" max-width="420" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ editando ? 'Editar vendedora IA' : 'Agregar al pool Ventas IA' }}
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="form.id_usuario"
            :items="usuariosDisponibles"
            item-text="nombre_completo"
            item-value="id_usuario"
            label="Vendedora (CRM)"
            filled
            dense
            hide-details
            class="mb-3"
            :disabled="editando"
            clearable
          ></v-autocomplete>
          <v-text-field
            v-model="form.nombre"
            label="Nombre (opcional)"
            filled
            dense
            hide-details
            class="mb-3"
          ></v-text-field>
          <v-text-field
            v-model.number="form.porcentaje"
            label="% de asignación"
            type="number"
            min="0"
            max="100"
            filled
            dense
            hide-details
            class="mb-3"
          ></v-text-field>
          <v-switch
            v-model="form.activo"
            :true-value="1"
            :false-value="0"
            label="Activa"
            dense
            hide-details
            class="mt-0"
          ></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-btn small dark color="black" tile @click="dialogForm = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small dark color="primary" tile :loading="guardando" @click="guardarForm">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="400">
      <v-card>
        <v-card-title class="text-subtitle-1">¿Quitar del pool?</v-card-title>
        <v-card-text>
          Se desactivará {{ (itemDelete && (itemDelete.nombre || itemDelete.id_usuario)) || '' }}.
        </v-card-text>
        <v-card-actions>
          <v-btn small text @click="dialogDelete = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn small dark color="red" :loading="guardando" @click="eliminarConfirm">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import validarErrores from '@/mixins/validarErrores'

export default {
  name: 'VentasIaPool',
  mixins: [validarErrores],
  props: {
    usuarios: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    cargando: false,
    cargandoEventos: false,
    guardando: false,
    pool: [],
    sumaPorcentaje: 0,
    eventos: [],
    dialogForm: false,
    dialogDelete: false,
    editando: false,
    itemDelete: null,
    form: {
      id: null,
      id_usuario: null,
      nombre: '',
      porcentaje: 0,
      activo: 1,
    },
    headers: [
      { text: 'ID', value: 'id', width: 60 },
      { text: 'Usuario CRM', value: 'id_usuario', width: 100 },
      { text: 'Nombre', value: 'nombre' },
      { text: '%', value: 'porcentaje', width: 90 },
      { text: 'Activa', value: 'activo', width: 80 },
      { text: 'Actions', value: 'actions', sortable: false, width: 90 },
    ],
    headersEventos: [
      { text: 'Fecha', value: 'fecha' },
      { text: 'Acción', value: 'accion' },
      { text: 'Score', value: 'score', width: 70 },
      { text: 'Destino', value: 'id_usuario_destino', width: 90 },
      { text: 'Motivo', value: 'motivo' },
      { text: 'Modo', value: 'dry_run', width: 70 },
    ],
  }),
  computed: {
    usuariosDisponibles() {
      const list = Array.isArray(this.usuarios) ? this.usuarios : []
      // En alta, preferir no repetir ids ya en pool (salvo edición)
      if (this.editando) return list
      const enPool = new Set(this.pool.map((p) => Number(p.id_usuario)))
      return list.filter((u) => !enPool.has(Number(u.id_usuario)))
    },
  },
  mounted() {
    this.cargarPool()
    this.cargarEventos()
  },
  methods: {
    formatFecha(f) {
      if (!f) return ''
      try {
        return new Date(f).toLocaleString('es-MX')
      } catch (_) {
        return String(f)
      }
    },
    cargarPool() {
      this.cargando = true
      return axios.post('via.ventas-ia.pool').then((response) => {
        const data = response.data || {}
        this.pool = Array.isArray(data.pool) ? data.pool : []
        this.sumaPorcentaje = Number(data.suma_porcentaje_activos) || 0
      }).catch((error) => {
        const msg = (error.response && error.response.data && error.response.data.message)
          || error.message
          || 'Error al cargar pool'
        this.validarError(msg)
      }).finally(() => {
        this.cargando = false
      })
    },
    cargarEventos() {
      this.cargandoEventos = true
      return axios.post('via.ventas-ia.eventos', { limit: 30 }).then((response) => {
        const data = response.data || {}
        this.eventos = Array.isArray(data.eventos) ? data.eventos : []
      }).catch(() => {
        this.eventos = []
      }).finally(() => {
        this.cargandoEventos = false
      })
    },
    abrirNuevo() {
      this.editando = false
      this.form = {
        id: null,
        id_usuario: null,
        nombre: '',
        porcentaje: 0,
        activo: 1,
      }
      this.dialogForm = true
    },
    abrirEditar(item) {
      this.editando = true
      this.form = {
        id: item.id,
        id_usuario: item.id_usuario,
        nombre: item.nombre || '',
        porcentaje: Number(item.porcentaje) || 0,
        activo: item.activo ? 1 : 0,
      }
      this.dialogForm = true
    },
    nombreDesdeUsuario(idUsuario) {
      const u = (this.usuarios || []).find((x) => Number(x.id_usuario) === Number(idUsuario))
      return (u && u.nombre_completo) || ''
    },
    guardarForm() {
      if (!this.form.id_usuario) {
        this.validarError('Selecciona una vendedora')
        return
      }
      const pct = Number(this.form.porcentaje)
      if (!Number.isFinite(pct) || pct < 0 || pct > 100) {
        this.validarError('El % debe estar entre 0 y 100')
        return
      }
      this.guardando = true
      const nombre = String(this.form.nombre || '').trim()
        || this.nombreDesdeUsuario(this.form.id_usuario)

      const req = this.editando && this.form.id
        ? axios.put(`via.ventas-ia.pool/${this.form.id}`, {
          nombre,
          porcentaje: pct,
          activo: this.form.activo ? 1 : 0,
        })
        : axios.post('via.ventas-ia.pool.upsert', {
          id_usuario: this.form.id_usuario,
          nombre,
          porcentaje: pct,
          activo: this.form.activo ? 1 : 0,
        })

      req.then(() => {
        this.dialogForm = false
        return this.cargarPool()
      }).catch((error) => {
        const msg = (error.response && error.response.data && error.response.data.message)
          || error.message
          || 'Error al guardar'
        this.validarError(msg)
      }).finally(() => {
        this.guardando = false
      })
    },
    guardarPorcentaje(item) {
      const pct = Number(item.porcentaje)
      if (!Number.isFinite(pct) || pct < 0 || pct > 100) {
        this.validarError('% inválido')
        return this.cargarPool()
      }
      return axios.put(`via.ventas-ia.pool/${item.id}`, {
        porcentaje: pct,
      }).then(() => this.cargarPool()).catch((error) => {
        const msg = (error.response && error.response.data && error.response.data.message)
          || 'Error al actualizar %'
        this.validarError(msg)
        this.cargarPool()
      })
    },
    toggleActivo(item) {
      return axios.put(`via.ventas-ia.pool/${item.id}`, {
        activo: item.activo ? 1 : 0,
      }).then(() => this.cargarPool()).catch((error) => {
        const msg = (error.response && error.response.data && error.response.data.message)
          || 'Error al cambiar activo'
        this.validarError(msg)
        this.cargarPool()
      })
    },
    confirmarEliminar(item) {
      this.itemDelete = item
      this.dialogDelete = true
    },
    eliminarConfirm() {
      if (!this.itemDelete || !this.itemDelete.id) return
      this.guardando = true
      axios.post('via.ventas-ia.pool.delete', { id: this.itemDelete.id })
        .then(() => {
          this.dialogDelete = false
          this.itemDelete = null
          return this.cargarPool()
        })
        .catch((error) => {
          const msg = (error.response && error.response.data && error.response.data.message)
            || 'Error al eliminar'
          this.validarError(msg)
        })
        .finally(() => {
          this.guardando = false
        })
    },
  },
}
</script>
